import { useTranslation } from "react-i18next";
import { Globe, Check } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const LANGS = [
  { code: "tr", label: "TR", name: "Türkçe" },
  { code: "en", label: "EN", name: "English" },
  { code: "de", label: "DE", name: "Deutsch" },
];

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const current = LANGS.find((l) => l.code === i18n.language) || LANGS[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="language-switcher-trigger"
          className="flex items-center gap-2 rounded-full border border-[#1a3636]/15 bg-white/60 px-4 py-2 text-sm font-medium text-[#1a3636] transition-all duration-300 hover:border-[#2b8a7e] hover:text-[#2b8a7e]"
        >
          <Globe size={16} strokeWidth={1.5} />
          <span>{current.label}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="min-w-[160px] rounded-xl border border-[#1a3636]/10 bg-white p-1 shadow-[0_20px_40px_rgb(26,54,54,0.12)]"
      >
        {LANGS.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            data-testid={`language-option-${lang.code}`}
            onClick={() => i18n.changeLanguage(lang.code)}
            className="flex cursor-pointer items-center justify-between rounded-lg px-3 py-2.5 text-sm text-[#1a3636] focus:bg-[#2b8a7e]/10 focus:text-[#1a3636]"
          >
            <span>
              <span className="font-semibold">{lang.label}</span>
              <span className="ml-2 text-[#8ca39f]">{lang.name}</span>
            </span>
            {i18n.language === lang.code && (
              <Check size={15} strokeWidth={2} className="text-[#2b8a7e]" />
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
